export default "__VITE_ASSET__DwtOL6JT__"